<template>
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z" fill="#F8F8F8"/>
        <path d="M14 27C6.8203 27 1 21.1797 1 14H-1C-1 22.2843 5.71573 29 14 29V27ZM27 14C27 21.1797 21.1797 27 14 27V29C22.2843 29 29 22.2843 29 14H27ZM14 1C21.1797 1 27 6.8203 27 14H29C29 5.71573 22.2843 -1 14 -1V1ZM14 -1C5.71573 -1 -1 5.71573 -1 14H1C1 6.8203 6.8203 1 14 1V-1Z" fill="#EEEEEE"/>
        <rect x="9" y="13.5459" width="10" height="0.909091" rx="0.454545" fill="#2D3E4F"/>
        <rect x="14.4545" y="9" width="10" height="0.909091" rx="0.454545" transform="rotate(90 14.4545 9)" fill="#2D3E4F"/>
    </svg>
</template>
<script>
export default { name: 'add-icon' }
</script>
